var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcGmxAvax(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 34,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 26.177 18.027 0 0 26.177h25.118l-7.088-9.99-3.517 5.191h-3.74l7.26-10.438 10.493 15.237H36Z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.999 23.09c0-5.524-4.477-10-10-10s-10 4.476-10 10c0 5.522 4.477 10 10 10s10-4.478 10-10Z",
    fill: "#E84142"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.999 14.34a8.75 8.75 0 1 0 0 17.498 8.75 8.75 0 0 0 0-17.499m0-1.25a10 10 0 1 1 0 20 10 10 0 0 1 0-20Z",
    fill: "#1E1F37"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.572 23.114a.483.483 0 0 1 .912 0l1.57 2.761c.25.436.046.793-.46.793h-3.165c-.5 0-.706-.356-.459-.793l1.602-2.76Zm-3.044-5.317a.477.477 0 0 1 .907 0l.35.631.827 1.452a1.51 1.51 0 0 1 0 1.315l-2.774 4.806a1.459 1.459 0 0 1-1.137.666h-2.3c-.5 0-.713-.35-.459-.793l4.586-8.077Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 18,
    y1: 0,
    x2: 7.492,
    y2: 28.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03D1CF",
    stopOpacity: 0.988
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E09F8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGmxAvax);
export default __webpack_public_path__ + "static/media/ic_gmx_avax.c79d2528e8ec8da55ffe44bae16d06a0.svg";
export { ForwardRef as ReactComponent };